import { Alert, Container, Link, Typography } from "@mui/material";
import { NavigationAndFooterLayout } from "../layouts";
import { NextPageWithLayout } from "@cm-websites/common";
import { NextSeo } from "next-seo";
import NextLink from "next/link";
import React from "react";

export const ContactPage: NextPageWithLayout = () => (
  <React.Fragment>
    <NextSeo
      description="Hast du Fragen, Anregungen oder Kritik zu unseren Krimidinnern für Zuhause? Dann schreib uns einfach. Wir freuen uns, von dir zu hören."
      title="Kontakt | Culinario Mortale®"
    />
    <Container
      maxWidth="md"
      sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}
    >
      <Typography variant="h1" sx={{ pb: 6 }}>
        So kannst du uns kontaktieren
      </Typography>
      <Typography variant="body1" paragraph>
        Hast du Fragen, Anregungen oder Kritik zu unseren Krimi-Dinner Spielen? Dann kontaktiere uns
        einfach unter{" "}
        <Link href="mailto:support@culinario-mortale.de">support@culinario-mortale.de</Link>.
      </Typography>
      <Typography variant="body1" paragraph>
        Wir freuen uns, von dir zu hören. Auch in dringenden Fällen geht es am schnellsten, wenn du uns
        eine Email schreibst. Dann melden wir uns i. d. R. binnen weniger Stunden bei dir.
      </Typography>
      <Alert severity="warning">
        Wenn du mit deinem Support-Code oder Zugangscode die Rollenbeschreibungen herunterladen möchtest,
        kannst du das <NextLink href="/vorbereitung">hier</NextLink> tun. Falls dir Materialien verloren
        gegangen sind, kannst du dir <NextLink href="/heft-verloren">hier</NextLink> Ersatz
        herunterladen.
      </Alert>
    </Container>
  </React.Fragment>
);

ContactPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default ContactPage;
